module.exports = __webpack_public_path__ + "img/corporateVision-img2.9c0ede86.png";